// Import stores first for utility hooks
import { useDialogStore } from './useDialogStore';
import { useUserStore } from './useUserStore';

// Export all individual stores
export { useClientStore, type ClientStore } from './useClientStore';
export { useDialogStore, type DialogStore } from './useDialogStore';
export { useItemStore, type ItemStore } from './useItemStore';
export { useSidebarStore, type SidebarStore } from './useSidebarStore';
export { useUserStore, type UserStore } from './useUserStore';
export { useEmployeeInvoiceDetailsStore } from './employeeInvoiceDetailsStore';
export { useCustomerSalesDialogStore } from './customerSalesDialogStore';
// Remove useThemeStore export to prevent conflicts with next-themes
// export { useThemeStore, type ThemeStore } from './useThemeStore';

// Utility hooks
export const useAuth = () => {
  const { isAuth, user, setUser, clearUser } = useUserStore();
  return {
    isAuth,
    user,
    setUser,
    clearUser,
  };
};

export const useGlobalLoading = () => {
  const { globalLoading, openGlobalLoading, closeGlobalLoading } =
    useDialogStore();
  return {
    isLoading: globalLoading?.isLoading || false,
    open: openGlobalLoading,
    close: closeGlobalLoading,
  };
};

// Legacy compatibility hooks (for gradual migration)

// All deprecated Redux exports have been removed
// Use individual Zustand store hooks instead
